import { HeaderContainer, Title } from './styles';
import CloseButton from '../close-button';

const ModalHeader = ({ title, onClose }) => (
  <HeaderContainer>
    <Title>{title}</Title>
    <CloseButton onClick={onClose} />
  </HeaderContainer>
);

export default ModalHeader;
